import {
    styled,
    ListSubheader as BaseListSubheader
} from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
import BaseRating from "./rating"
import { brand } from "../theme";

export const ListSubheader = styled(({...p}) =>
    <BaseListSubheader disableSticky {...p} />
)(({theme}) => ({
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    height: theme.spacing(4)
}))

export const RoundBadge = styled(({ canEdit, ...p }: { canEdit?: boolean; [k: string]: any }) =>
    <div {...p} />
)(({ canEdit }: { canEdit?: boolean }) => ({
    width: 34,
    height: 34,
    borderRadius: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    fontSize: 13,
    flexShrink: 0,
    color: canEdit ? brand.amberDeep : brand.textDis,
    background: canEdit ? brand.amberLight : brand.surface,
    transition: 'background .2s, color .2s',
}));

export const Asterisks = styled(({ double, ...p }: { double?: boolean; [k: string]: any }) =>
    <span {...p}>{double ? '✱✱' : '✱'}</span>
)(({theme}) => ({
    marginLeft: theme.spacing(1),
    color: brand.amber,
    fontWeight: 800,
    filter: `drop-shadow(0 0 4px ${brand.amber}70)`,
}))

export const DisclosureIndicator = styled(({...p}) =>
    <ArrowForwardIos {...p} />
)({
    fontSize: 14,
    color: brand.textDis,
});

export const Rating = styled(({...p}) =>
    <BaseRating {...p} />
)({
    paddingTop: 1,
});

export const ReminderChip = styled(({ secondaryBeer, ...p }: { secondaryBeer: string; [k: string]: any }) =>
    <span {...p}>
        <span className="kicker">2ND</span>
        <span className="name">{secondaryBeer}</span>
    </span>
)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 10,
    fontWeight: 700,
    color: brand.amberDeep,
    background: brand.amberLight,
    padding: "2px 7px",
    borderRadius: 999,
    letterSpacing: 0.3,
    marginLeft: theme.spacing(1),
    "& .kicker": {
        fontSize: 8,
        fontWeight: 900,
    },
    "& .name": {
        fontWeight: 600,
    },
}));

export const LottoBadge = styled(({ ...p }: { [k: string]: any }) =>
    <span {...p}>
        <span aria-hidden>🎰</span>
        <span>LOTTO</span>
    </span>
)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0.6,
    color: brand.white,
    background: `linear-gradient(135deg, ${brand.amber} 0%, #E8741A 100%)`,
    padding: "2px 6px",
    borderRadius: 4,
    textTransform: "uppercase",
    boxShadow: `0 2px 6px ${brand.amber}66`,
    marginLeft: theme.spacing(1),
    verticalAlign: "middle",
}));

export const NoteChip = styled(({ note, ...p }: { note: string; [k: string]: any }) =>
    <span title={note} {...p}>
        Note
    </span>
)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 10,
    fontWeight: 700,
    color: brand.textSec,
    background: brand.surface,
    padding: "2px 7px",
    borderRadius: 999,
    border: `1px solid ${brand.sep}`,
    marginLeft: theme.spacing(1),
}));
